<template>
  <div class="ParticipantMenu">
    <div class="container-fluid">
        <div class="row margin-top-3-perc">
            <div class="col-sm-2 col-md-2 col-lg-2">
            </div>
            <div class="col-sm-2 col-md-2 col-lg-2">
              <!-- ToDo: Track this -->
                <button type="button" class="btn gray-border input-block-level custom-btn white-BG col-xs-12 col-sm-12 col-md-12 col-lg-12" v-bind:class="{'background-blue': isActive === 1 && isCreateParticipantBtnClicked && !isEnrollParticipantClicked && !isToolkitAndEnrollmentsClicked && !isUnEnrollParticipantClicked}" v-on:click="updateIsCreateParticipantFlag($event,true),updateColorButton($event,1)">Create</button>
            </div>
            <div class="col-sm-2 col-md-2 col-lg-2">
              <!-- ToDo: Track this -->
                <button type="button" class="btn gray-border input-block-level custom-btn white-BG col-xs-12 col-sm-12 col-md-12 col-lg-12" v-bind:class="{'background-blue': isActive === 2 && !isCreateParticipantBtnClicked && isEnrollParticipantClicked && !isToolkitAndEnrollmentsClicked && !isUnEnrollParticipantClicked}" v-on:click="updateEnrollParticipantClickedFlag($event,true),updateColorButton($event,2)">Enroll</button>
            </div>
            <div class="col-sm-2 col-md-2 col-lg-2">
              <!-- ToDo: Track this -->
                <button type="button" class="btn gray-border input-block-level custom-btn white-BG col-xs-12 col-sm-12 col-md-12 col-lg-12" v-bind:class="{'background-blue': isActive === 4 && !isCreateParticipantBtnClicked && !isEnrollParticipantClicked && !isToolkitAndEnrollmentsClicked && isUnEnrollParticipantClicked}" v-on:click="updateUnEnrollParticipantClickedFlag($event,true),updateColorButton($event,4)">Un-enroll</button>
            </div>
            <div class="col-sm-2 col-md-2 col-lg-2">
              <!-- ToDo: Track this -->
                <!-- <button type="button" class="btn gray-border input-block-level custom-btn white-BG col-lg-12" v-on:click="updateToolkitAndEnrollmentsClickedFlag($event,true)">Toolkit & Enrollments</button> -->
                 <button type="button" class="btn gray-border input-block-level custom-btn white-BG col-lg-12" v-bind:class="{'background-blue': isActive === 3 && !isCreateParticipantBtnClicked && !isEnrollParticipantClicked && isToolkitAndEnrollmentsClicked && !isUnEnrollParticipantClicked}" v-on:click="updateToolkitAndEnrollmentsClickedFlag($event,true),updateColorButton($event,3)">Toolkit & Enrollments</button>
            </div>
            <div class="col-sm-2 col-md-2 col-lg-2">
            </div>    
        </div>
         <!-- End of Show Participant List UI    -->
        <!-- Start of Create Participant Tab UI-->  
        <div class="row margin-top-1-perc" v-if="isCreateParticipantBtnClicked">
          <div class="col-md-2 col-lg-2 cursor-pointer text-align-left margin-left-1Perc margin-left-1Point4Perc" v-on:click="updateIsCreateParticipantFlag($event,false)">
            {{backToparticipantList}}
          </div>
          <div class="col-md-9 col-lg-9">
          </div>  
        </div>  
        <create-participant-tab v-if="isCreateParticipantBtnClicked" @clickedTab="onClickCreateParticipantChildTabValue"></create-participant-tab>  
        <!-- End of Create Participant Tab UI-->

        <!-- Start of Enroll Paricipants UI-->  
        <div class="row margin-top-1-perc" v-if="isEnrollParticipantClicked">
          <div class="col-md-2 col-lg-2 cursor-pointer text-align-left margin-left-1Point4Perc" v-on:click="updateEnrollParticipantClickedFlag($event,false)">
            {{backToparticipantList}}
          </div>
          <div class="col-md-9 col-lg-9">
          </div>  
        </div>  
        <enroll-participant-tab v-if="isEnrollParticipantClicked" @clickedTab="onClickEnrollParticipantChildTabValue"></enroll-participant-tab>  
        <!-- End of Enroll Paricipants UI-->


        <!-- Start of UnEnroll Paricipants UI-->  
        <div class="row margin-top-1-perc" v-if="isUnEnrollParticipantClicked">
          <div class="col-md-2 col-lg-2 cursor-pointer text-align-left margin-left-1Point4Perc" v-on:click="updateUnEnrollParticipantClickedFlag($event,false)">
            {{backToparticipantList}}
          </div>
          <div class="col-md-9 col-lg-9">
          </div>  
        </div>  
        <un-enroll-participant-tab v-if="isUnEnrollParticipantClicked" @clickedTab="onClickUnEnrollParticipantChildTabValue"></un-enroll-participant-tab>  
        <!-- End of UnEnroll Paricipants UI-->

        <!-- Start of toolkit and Enrolment Paricipants UI-->  
        <div class="row margin-top-1-perc" v-if="isToolkitAndEnrollmentsClicked">
          <div class="col-md-2 col-lg-2 cursor-pointer text-align-left margin-left-1Point4Perc" v-on:click="updateToolkitAndEnrollmentsClickedFlag($event,false)">
            {{backToparticipantList}}
          </div>
          <div class="col-md-9 col-lg-9">
          </div>  
        </div>  
        <toolkits-and-enrollment-filter-bar v-if="isToolkitAndEnrollmentsClicked" @clickedTab="onClickToolkitAndEnrollmentOptionValue" v-bind:resetFilter="resetUnEnrolledParticipantFilter"></toolkits-and-enrollment-filter-bar>  
        <!-- End of toolkit and Enrolment Paricipants UI-->
      </div>   
    </div>
</template>

<script>
import CreateParticipantTab from '@/components/CreateParticipantTab'
import EnrollParticipantTab from '@/components/EnrollParticipantTab'
import UnEnrollParticipantTab from '@/components/UnEnrollParticipantTab'
import ToolkitAndEnrollmentsFilterBar from '@/components/ToolkitAndEnrollmentsFilterBar'
export default {
  created: function () {},
  data: function () {
    return {
      isActive: -1,
      isCreateParticipantBtnClicked: false,
      isEnrollParticipantClicked: false,
      isUnEnrollParticipantClicked: false,
      isToolkitAndEnrollmentsClicked: false,
      backToparticipantList: '< Participant List',
      resetUnEnrolledParticipantFilter: false
    }
  },
  components: {
    'create-participant-tab': CreateParticipantTab,
    'enroll-participant-tab': EnrollParticipantTab,
    'un-enroll-participant-tab': UnEnrollParticipantTab,
    'toolkits-and-enrollment-filter-bar': ToolkitAndEnrollmentsFilterBar
  },
  methods: {
    updateIsCreateParticipantFlag: function (event, flagToUpdate) {
      // AK: Show/Hide Participant List as per flag
      this.$emit('showParticipantList', !flagToUpdate)
      this.isCreateParticipantBtnClicked = flagToUpdate
      // AK: Hide by default all UI
      this.isEnrollParticipantClicked = false
      this.isUnEnrollParticipantClicked = false
      this.isToolkitAndEnrollmentsClicked = false
    },
    updateColorButton: function (event, flagToUpdate) {
      this.isActive = flagToUpdate
      this.$emit('clickedTab', flagToUpdate)
    },
    onClickCreateParticipantChildTabValue (value) {
      // AK: (Not in use)
      this.clickedCreateParticipantTab = value
    },
    updateEnrollParticipantClickedFlag: function (event, flagToUpdate) {
      // AK: Show/Hide Participant List as per flag
      this.$emit('showParticipantList', !flagToUpdate)
      this.isEnrollParticipantClicked = flagToUpdate
      // AK: Hide by default all UI
      this.isCreateParticipantBtnClicked = false
      this.isUnEnrollParticipantClicked = false
      this.isToolkitAndEnrollmentsClicked = false
    },
    updateUnEnrollParticipantClickedFlag: function (event, flagToUpdate) {
      // AK: Show/Hide Participant List as per flag
      this.$emit('showParticipantList', !flagToUpdate)
      this.isUnEnrollParticipantClicked = flagToUpdate
      // AK: Hide by default all UI
      this.isEnrollParticipantClicked = false
      this.isCreateParticipantBtnClicked = false
      this.isToolkitAndEnrollmentsClicked = false
    },
    onClickEnrollParticipantChildTabValue (value) {
      this.clickedEnrollParticipantTab = value
    },
    onClickUnEnrollParticipantChildTabValue (value) {
      this.clickedUnEnrollParticipantTab = value
    },
    updateToolkitAndEnrollmentsClickedFlag: function (event, flagToUpdate) {
      // AK: Show/Hide Participant List as per flag
      this.$emit('showParticipantList', !flagToUpdate)
      this.isToolkitAndEnrollmentsClicked = flagToUpdate
      this.resetUnEnrolledParticipantFilter = !this.resetUnEnrolledParticipantFilter
      // AK: Hide by default all UI
      this.isCreateParticipantBtnClicked = false
      this.isEnrollParticipantClicked = false
      this.isUnEnrollParticipantClicked = false
    },
    onClickToolkitAndEnrollmentOptionValue (value) {
      this.clickedEnrollParticipantTab = value
    }
  },
  computed: {},
  name: 'ParticipantMenu'
}
</script>

<style scoped>
.input-group .icon-addon .form-control {
  border-radius: 0;
}

.icon-addon {
  position: relative;
  color: #555;
  display: block;
}

.icon-addon:after,
.icon-addon:before {
  display: table;
  content: " ";
}

.icon-addon:after {
  clear: both;
}

.icon-addon.addon-md .glyphicon,
.icon-addon .glyphicon,
.icon-addon.addon-md .fa,
.icon-addon .fa {
  position: absolute;
  z-index: 2;
  left: 10px;
  font-size: 14px;
  width: 20px;
  margin-left: -2.5px;
  text-align: center;
  padding: 8px 0;
  top: 1px;
}

.icon-addon.addon-lg .form-control {
  line-height: 1.33;
  height: 30px;
  border-radius: 15px;
  font-size: 13px;
  padding: 10px 16px 10px 40px;
}

.icon-addon.addon-sm .form-control {
  height: 30px;
  padding: 5px 10px 5px 28px;
  font-size: 12px;
  line-height: 1.5;
}

.icon-addon.addon-lg .fa,
.icon-addon.addon-lg .glyphicon {
  font-size: 14px;
  margin-left: 0;
  left: 11px;
  top: 0px;
}

.icon-addon.addon-md .form-control,
.icon-addon .form-control {
  padding-left: 30px;
  float: left;
  font-weight: normal;
}

.icon-addon.addon-sm .fa,
.icon-addon.addon-sm .glyphicon {
  margin-left: 0;
  font-size: 12px;
  left: 5px;
  top: -1px;
}

.icon-addon .form-control:focus + .glyphicon,
.icon-addon:hover .glyphicon,
.icon-addon .form-control:focus + .fa,
.icon-addon:hover .fa {
  color: #2580db;
}
.border-color-red {
  border: 1px solid red;
}
.border-color-green {
  border: 1px solid green;
}
.width-70Perc {
  width: 70%;
}
.width-90Perc {
  width: 90%;
}
.text-align-left {
  text-align: left !important;
}
.Padding-left-0px {
  padding-left: 0px !important;
}
.font-size-18px {
  font-size: 18px;
}
.margin-top-1Per {
  margin-top: 1%;
}
.margin-top-2-perc {
  margin-top: 2%;
}
.background-gray {
  background-color: #ddd;
}
.margin-bottom-0px {
  margin-bottom: 0px !important;
}
.gray-border {
  border: 1px solid #aaa;
}
.white-BG {
  background-color: #ffffff;
}
.margin-top-3-perc {
  margin-top: 3%;
}
.margin-top-1-perc {
  margin-top: 1%;
}
.right-border-color {
  /*border-right: 1px solid #43495e;*/
}
.vertical-align {
  display: flex;
  align-items: center;
}
.width-1Perc {
  width: 1% !important;
}
.cursor-pointer {
  cursor: pointer;
}
.width-9-Perc {
  width: 9% !important;
}
@media (max-width: 1024px) {
  .width-9-Perc {
    width: 11.5% !important;
  }
}
.font-weight-bold
{
  font-weight: bold;
}
.font-size-15px
{
  font-size: 15px;
}
.border-red{
  border: 1px solid red;
}
.border-yellow{
  border: 2px solid yellow !important;
}
.margin-left-2Point2Perc{
  margin-left:2.2%;
}
.margin-left-1Point6Perc{
  margin-left:1.6%;
}
.margin-left-1Point4Perc{
  margin-left:1.4%;
}
.background-blue {
  background-color: #286090;
  color: #fff;
  border-color: #2e6da4;
}

</style>



// WEBPACK FOOTER //
// src/components/ParticipantMenu.vue